'use client';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { ThemeCssVarOverrides, ThemeProviderProps } from '@mui/material/styles';
import { GlobalStyles } from '@/styles/global/global.styles';
import { theme as baseTheme } from '@/styles/theme/mui-theme';
import { FC } from 'react';

interface Props extends Omit<ThemeProviderProps, 'theme'> {
  themeOverrides?: ThemeCssVarOverrides;
}

export const MuiProvider: FC<Props> = ({ children, themeOverrides, ...props }) => {
  const theme = themeOverrides ? createTheme(baseTheme, themeOverrides) : baseTheme;

  return (
    <ThemeProvider {...props} theme={theme}>
      <CssBaseline enableColorScheme />
      <GlobalStyles />
      {children}
    </ThemeProvider>
  );
};
